import {useChatbotStore} from '@features/chatbot/store/chatbotStore.ts'
import {CHATBOT_SOURCES} from '@features/chatbot/types.ts'
import {useEffect, useState} from 'react'
import {useTranslation} from 'react-i18next'

interface GetInfoProps {
    flowSource: string
}

export function GetInfo({flowSource}: GetInfoProps) {
    const selectedShoot = useChatbotStore(store => store.selectedAssignment)
    const addStepToHistory = useChatbotStore(store => store.addStepToHistory)
    const bedrooms = selectedShoot?.entity?.bedrooms
    const [paragraph, setParagraph] = useState('')
    const {t} = useTranslation()

    useEffect(() => {
        const hostEmail = selectedShoot?.host?.email
        const hostNumber = selectedShoot?.host?.phone
        switch (flowSource) {
            case 'MB1_yes_pull':
            case 'MB1_no_pull':
                addStepToHistory({
                    id: flowSource,
                    source: CHATBOT_SOURCES.CHATBOT,
                    text: `This is the number of bedrooms based on the listing info: ${
                        bedrooms || '-'
                    }. How many bedrooms did you shoot?`
                })
                setParagraph(
                    t('chatbot:get_info:mb1_no_pull', {
                        bedrooms: bedrooms || '-'
                    })
                )
                break
            case 'MB1.3_email':
                addStepToHistory({
                    id: flowSource,
                    source: CHATBOT_SOURCES.CHATBOT,
                    text: `Please email the Host directly at: ${hostEmail || '-'}`
                })
                setParagraph(
                    t('chatbot:get_info:mb1.3_email', {
                        hostEmail: hostEmail || '-'
                    })
                )
                break
            case 'MB1.3.3_no':
                addStepToHistory({
                    id: flowSource,
                    source: CHATBOT_SOURCES.CHATBOT,
                    text: `Please contact the Host at: ${hostNumber || '-'}`
                })
                setParagraph(
                    t('chatbot:get_info:mb1.3.3_no', {
                        hostNumber: hostNumber || '-'
                    })
                )
                break
        }
    }, [flowSource, selectedShoot, bedrooms, addStepToHistory, t])

    return <p>{paragraph}</p>
}
